export enum EnumTipoOperacion {
  TipoOperacionInvalido = 0,
  Regasificacion = 1,
  CargaCisterna = 2,
  CargaBuque = 3,
  DescargaBuque = 4,
  EntradaRtPCPR = 5,
  EntradaRtPCI = 6,
  EntradaRtPCY = 7,
  SalidaRtPCI = 9,
  DemandaConvencional = 11,
  DemandaLLDD = 12,
  DemandaOtros = 13,
  Compra = 17,
  Venta = 18,
  DemandaLLDDME = 19,
  AjustesGNL = 21,
  Mermas = 23,
  CompraVenta = 24,
  Desbalance = 25,
  E_S_AASS = 26,
  InyExt_AASS = 27,
  Licuefaccion = 28,
  SalidaRT_PCTVB = 29,
  Almacenamiento_PVB = 30,
  Almacenamiento_TVB = 31,
  Desbalance_TVB = 32,
  Desbalance_AASS = 33,
  DescargaCisterna = 34,
  EMS = 41,
  Inyección = 42,
  Extracción = 43,
  Plan_Invernal = 45,
  Etrada_PCAS = 47,
  Salida_PCAS = 48,
  Existencias = 50,
  Entrada_RT_PPBD = 51,
  DemandaCisternas = 52,
  CapacDiariaRegasificacion = 53,
  CapacDiariaCargaCisterna = 54,
  CapacDiariaCargaBuque = 55,
  CapacDiariaDescargaBuque = 56,
  CapacDiariaEntradaRT = 57,
  CapacDiariaSalidaCI = 58,
  CapacDiariaInyeccion = 59,
  CapacDiariaExtraccion = 60,
  CapacDiariaDistribucionG1 = 61,
  CapacDiariaLicuefaccion = 62,
  CapacDiariaAlmacenamientoGN = 63,
  CapacDiariaAlmacenamientoGNL = 64,
  CapacDiariaAlmacenamientoPVB = 65,
  EntradaRNTGN = 66,
  SaídaRNTGN = 67,
  Descarga = 68,
  DescargaSimples = 69,
  Recarga = 70,
  RecargaSimples = 71,
  EntregaGN = 72,
  RecepcionGN = 73,
  RegasificacionPT = 74,
  InyeccionPT = 75,
  ExtraccionPT = 76,
  LicuefaccionPT = 77,
  EntradaRNTGNPCI = 78,
  EntradaRNTGNAASS = 79,
  SaidaRNTGNPCI = 80,
  SaidaRNTGNAASS = 81,
  MND = 82,
  MD = 83,
  MI = 84,
  AjustamentoMND = 85,
  Linepack = 86,
  LinepackAcumulado = 87,
  DesequilibrioVoluntario = 88,
  AjustamentoPA = 89,
  Correcciones = 90,
  Stock = 99
}